import React from "react";
import PropTypes from 'prop-types';
import graphql from 'babel-plugin-relay/macro';
import {QueryRenderer, createFragmentContainer} from 'react-relay';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {isEmpty} from 'lodash'

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import withStyles from '@material-ui/core/styles/withStyles';
import SearchField from '../../SearchField';
import ListComponent from './ListComponent';

import Typography from '../../Typography';
import Hidden from '@material-ui/core/Hidden';

import TopNav from '../../TopNav';

const styles = theme => ({
  container: {
    flexWrap:'nowrap',
    height:'100%',
    overflowY:'scroll',
    overflowX: 'hidden',
    maxWidth:'calc(100% + 35px)',
    flex: 1,
    marginLeft:0,
  },
  container_big_screens: {
      marginLeft: -35
  },
  root: {
    background:theme.palette.white,
    boxShadow: "0px 4px 4px rgba(204, 204, 204, 0.25)",
    flex: 1,
    width:'100%',
    height:'100%',
    border:`1px solid ${theme.palette.divider}`,
    position:'relative'
  },
  arrow: {
    width:56,
    height:56,
    overflow:'hidden',
    position:'relative',
    marginRight: -1,
    alignSelf:'flex-end',
    justifySelf:'flex-start',
    '&:after': {
      content: '""',
      position:"absolute",
      top:11,
      left:42,
      width:32,
      height:32,
      background:theme.palette.white,
      transform:'rotate(135deg)',
      boxShadow: "0px 4px 4px rgba(204, 204, 204, 0.25)",
      border:'1px solid #eee',
    },
  },
  divider: {
    position:"relative",
    height:'100%',
    padding:0,
    '&:last-child': {
      paddingBottom:0,
    }
  },
  section: {
    flex: 1,
    height:'100%',
    '&:first-child': {
      borderRight:'1px solid #eee',
    }
  },
  list_section_container: {
    position:'relative',
    width:'100%',
    height:'100%',
  },
  grid_container: {
    height:'100%'
  }
})


const suborgs_query = graphql`
    query ChangerComponentQuery($orgId: ID!, $name: String) {
      authorizedSuborgs(orgId: $orgId, name: $name) {
        ...SimpleList_suggestions
        ...LocalContainer_suggestions
        ...List_suggestions
      }
    }
`;

export default createFragmentContainer(

  React.memo(withStyles(styles)(({ classes, close_bottom_section, ...props }) => {

    const default_org = props.orgs[0];
    const [state, set] = React.useState({
      temp_selected_org: default_org
    })

    function select_org(e, org) {
      props.select_org_property({ selected_property: {}, selected_org: org })
      close_bottom_section()
    }


    function select_property(e, property) {
      const no_event = isEmpty(e);
      props.select_org_property({
        selected_org: state.temp_selected_org,
        selected_property: property
      })
      if (!no_event) { close_bottom_section() }
    }

    function change_org(e, org) {
      set({ temp_selected_org: org});
    }

    React.useEffect(() => {
      const temp_selected_org = (props.orgs_state && props.orgs_state.selected_org && Boolean(props.orgs_state.selected_org.id))
              ? props.orgs_state.selected_org
              : default_org;
      set({ temp_selected_org });
    },[props.orgs_state])

    const matches = useMediaQuery('(min-width:768px)');

    const Container = React.useMemo(() => {
      return matches ? ({children}) => <>{children}</> : TopNav
    }, [matches]);

    const container_class = classes.container + (matches ? ' ' +classes.container_big_screens : '');

    return (

      <Grid container direction = "row-reverse" className = {container_class}>
        <Container
            pathnames = ""
            no_shadow
            no_border
            toggleDrawer = {close_bottom_section}
         >
          <Card className = {classes.root}>
            <CardContent className = {classes.divider} >
              <Grid container className = {classes.grid_container}>
                <Grid item xs = {6} className = {classes.section}>
                  <div className = {classes.list_section_container}>
                    <ListComponent
                        suggestions = {props.orgs}
                        onSelect = {select_org}
                        selected_value = {props.orgs_state.selected_org && props.orgs_state.selected_org.id}
                        temp_selection = {state.temp_selected_org.id}
                        onmouseover_function = {change_org}
                    />
                  </div>
                </Grid>
                <Grid item xs={6} className = {classes.section}>
                  <div className = {classes.list_section_container}>
                    <SearchField
                      {...props}
                      query = {suborgs_query}
                      fetch_type = "fetch"
                      query_name = "authorizedSuborgs"
                      variables = {{ orgId: state.temp_selected_org.id }}
                      selected_icon_type = "icon-check-single"
                      onSelect= {select_property}
                      selected_value = { props.orgs_state.selected_property &&  props.orgs_state.selected_property.id}
                      show_on_load
                      initial_open
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
         </Container>
         {
           matches
           ? <div className = {classes.arrow}/>
           : null
         }
      </Grid>
    );
  })),
  {
  orgs: graphql`
    fragment ChangerComponent_orgs on PicklistInterface @relay(plural:true)
    {
      id
      name
      ...ListComponent_suggestions
    }
  `
})
